import React, { useEffect, useState } from 'react'

import { CSVLink } from 'react-csv'

import { Icon } from '../../components/Icon'
import {
  WhistleblowingHeaders,
  WhistleblowingHeadersAdmin,
} from '../../data/index'
import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UITextArea from '../../components/UI/UITextArea'

import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import UIButton from '../../components/UI/UIButton'
import UiSelect from '../../components/UI/UISelect'
// import Pagination from '../../components/UI/Pagination'
import '../../App.css'
import {
  ErrorResponse,
  whistleBlowing,
  whistleblowingComment,
  whistleblowingCommentResponse,
  whistleblowingData,
  whistleblowingDataResponseObject2,
  whistleblowingResponse,
  whistleblowingResponseObj,
  // whistleblowingSingleCountResponse,
  // whistleblowingSingleResponse,
  // whistleblowingUrl,
} from '../../utils/types'
import {
  addWistleBlowingComments,
  getWistleBlowingComments,
  updateWhistleBlowingStatus,
} from '../../api/candidate/whistleBlowing'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import { formatDate, statusBgColorWhistleblowing } from '../../utils/utils'
import Loading from '../../components/UI/Loading'
// import axios, { AxiosResponse } from 'axios'
// import { BASE_URL } from '../../api/endpoints'
import UIMultiSelect from '../../components/UI/UIMultiSelect'
import {
  exportToExcel,
  handleDownloadHtml,
  handleDownloadTxt,
} from '../policy/utils'
import { UIExportHtmlTable } from '../../components/UI/UIExportHtmlTable'
import {
  deleteWhistleBlowing,
  getSingleWistleBlowingById,
  getWhistleBlowing,
} from '../../api/admin/whistleblowing'
import { createWhistleBlowing } from '../../api/lead/whistleblowing'
import UIRadiobutton from '../../components/UI/UIRadiobutton'
import WhistleBlowingAboutOfficer from '../../components/WhistleBlowingAboutOfficer'
import UITextInput from '../../components/UI/UITextInput'

interface WhistleblowingHeadersInterface {
  ID: string
  Status: string
  Subject: string
  'Report Type': string
  'Date Reported': string
  'Updated At': string
  'Created By': string
  'Updated By': string
}

const Whistleblowing = () => {
  // const queryClient = useQueryClient()
  const [isExportOpen, setIsExportOpen] = useState<boolean>(false)
  const [isOpenCreate, setIsOpenCreate] = useState(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [isOpenMenuButton, setIsOpenMenuButton] = useState(false)
  const [id, setId] = useState<string>('')
  const [whistleblowingId, setWhistleblowingId] = useState('')
  const [isView, setIsView] = useState(false)
  const [status, setStatus] = useState('')
  const [isConfidentialSelected, setIsConfidentialSelected] = useState(false)
  const [isAnonymousSelected, setIsAnonymousSelected] = useState(false)
  const [aboutOfficer, setAboutOfficer] = useState(false)
  const [description, setDescription] = useState<string>('')
  const [subject, setSubject] = useState<string>('')
  // const [url, setUrl] = useState('')

  // const [currentPage, setCurrentPage] = useState<number>(1)
  const [fileType, setFileType] = useState<string>('')
  const [fileHeader] = useState([
    { key: 'ID', label: 'ID' },
    { key: 'Status', label: 'Status' },
    { key: 'Subject', label: 'Subject' },
    { key: 'Report_Type', label: 'Report_Type' },
    { key: 'Date_Reported', label: 'Date_Reported' },
    { key: 'Updated_At', label: 'Updated_At' },
    { key: 'Created_By', label: 'Created_By' },
    { key: 'Updated_By', label: 'Updated_By' },
  ])
  const [comment, setComment] = useState('')
  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    //  console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      //  console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }
  const handleExportOpenModal = () => {
    setIsExportOpen(true)
  }

  const handleExportCloseModal = () => {
    setIsExportOpen(false)
  }

  const handleConfidentialClick = () => {
    setIsConfidentialSelected(true)
    setIsAnonymousSelected(false)
  }

  const handleAnonymousClick = () => {
    setIsConfidentialSelected(false)
    setIsAnonymousSelected(true)
  }

  const getWhistleBlowingData =
    async (): Promise<whistleblowingResponseObj> => {
      const response = (await getWhistleBlowing(
        // currentPage,
        sortBy,
        sortOrderValue
      )) as whistleblowingResponse

      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  // const token = sessionStorage.getItem('authToken')
  // const getUrl = (): void => {
  //   console.log(
  //     {
  //       Authorization: `Bearer ${token}`,
  //     },
  //     sessionStorage.getItem('authToken')
  //   )

  //   axios
  //     .get(`${BASE_URL}/whistle-blowings/url`, {
  //       headers: {
  //         Authorization: `Bearer ${sessionStorage.getItem('authToken')}`,
  //       },
  //     })
  //     .then(function (response: AxiosResponse<whistleblowingUrl>) {
  //       setIsOpenCopy(true)

  //       setUrl(response?.data?.Url)
  //       console.log('Response:', response.data)
  //     })
  //     .catch(function (error) {
  //       console.error('Error:', error)
  //     })
  // }

  const getwhistleBlowingDataById = async (): Promise<whistleblowingData> => {
    const response = (await getSingleWistleBlowingById(
      id
    )) as whistleblowingDataResponseObject2

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const getwhistleBlowingComments = async (): Promise<
    whistleblowingComment[]
  > => {
    const response = (await getWistleBlowingComments(
      whistleblowingId
    )) as whistleblowingCommentResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }
  const whistleBlowingById = useQuery(
    ['whistleblowingById', id],
    getwhistleBlowingDataById,
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )
  const whistleBlowing = useQuery('whistleBlowing', getWhistleBlowingData)
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(whistleBlowing?.data?.data?.length || 100).fill(false)
  )
  const whistleBlowingComment = useQuery(
    ['whistleblowinComment', whistleblowingId],
    getwhistleBlowingComments,
    {
      enabled: !!whistleblowingId, // Only fetch data when id is truthy
    }
  )

  const changeStatus = async (): Promise<void> => {
    try {
      const response = (await updateWhistleBlowingStatus(
        {
          status: status,
        },
        // The list holds invitations; the status endpoint needs the report itself
        whistleblowingId
      )) as {
        status?: string
        data: whistleblowingData
      }
      if (response?.status == 'successful') {
        whistleBlowingById.refetch()
        // setIsOpen(!isOpen)

        toast.success('status Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const addComment = async (): Promise<void> => {
    const response = (await addWistleBlowingComments(
      {
        comment: comment,
      },
      whistleblowingId
    )) as {
      status?: string
      data: whistleblowingData
    }
    if (response?.status == 'successful') {
      whistleBlowingComment.refetch()
      // setIsOpen(!isOpen)
      setComment('')
      toast.success('Comment Added.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const removePolicy = async (): Promise<void> => {
    try {
      const response = (await deleteWhistleBlowing({ id: id })) as {
        status?: string
        data: whistleblowingData
      }
      if (response?.status == 'successful') {
        whistleBlowing.refetch()
        setIsOpen(false)
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  // const calculatePageCount = (dataLength: number): number => {
  //   if (dataLength < 4) {
  //     return 1
  //   } else {
  //     return Math.ceil(dataLength / 3)
  //   }
  // }

  const createWhistle = async (): Promise<void> => {
    console.log('caniddate api')

    const response = (await createWhistleBlowing({
      // Anonymous reports must not carry the reporter's email
      email: isConfidentialSelected
        ? localStorage.getItem('userEmail') || ''
        : '',
      subject: subject,
      description: description,
      reportType: isConfidentialSelected == true ? 'user' : 'anonymous',
      aboutOfficer,
    })) as {
      status?: string
      data: whistleBlowing
    }
    if (response?.status == 'successful') {
      // setIsOpen(!isOpen)
      setIsOpenCreate(false)
      setIsOpen(false)
      handleCloseModal()
      setAboutOfficer(false)
      whistleBlowing.refetch()
      toast.success('Whistleblowing Report Created.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  // useEffect(() => {
  //   whistleBlowing.refetch()
  // }, [currentPage])

  useEffect(() => {
    whistleBlowing.refetch() // Refetch Whistle Blowing when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const columns = [
    {
      title: 'ID',
      column: 'reportNo',
    },
    {
      title: 'Status',
      column: 'status',
    },
    {
      title: 'Subject',
      column: 'subject',
    },

    {
      title: 'Report Type',
      column: 'reportType',
    },
    {
      title: 'Date Reported',
      column: 'createdAt',
    },

    {
      title: 'Updated At',
      column: 'updatedAt',
    },
    {
      title: 'Created By',
      column: 'createdByName',
    },
    {
      title: 'Updated By',
      column: 'updatedByName',
    },
  ]

  console.log('whs data', whistleBlowingById.data)

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-[30px] w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>
                Whistleblowing
              </p>
              {/* <p
                className={
                  'text-[14px] font-normal text-text1 leading-[24px] mt-2'
                }
              >
                Please add your whistleblowing reports here. You can give
                various reasons and solutions, and specify their severity level.
              </p> */}
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              {/* <div
                onClick={getUrl}
                className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-text1'}>
                  Whistleblowing URL
                </p>
                <Icon
                  name={'copyIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div> */}

              <div
                onClick={() => {
                  if (whistleBlowing?.data?.data?.length != 0) {
                    handleExportOpenModal()
                  } else {
                    toast.info('No data available.', {
                      position: 'top-right',
                    })
                  }
                }}
                className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-text1'}>
                  Export Report
                </p>
                <Icon
                  name={'exportIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div>
              <div className={'flex flex-row gap-[15px]'}>
                <div className={'flex flex-row gap-[15px]'}>
                  <div
                    onClick={() => {
                      setIsOpenCreate(true)
                    }}
                    className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
                  >
                    <p className={'font-medium text-[14px] text-white'}>
                      Create Report
                    </p>
                    <Icon
                      name={'IconPlus'}
                      strokeWidth={1}
                      stroke={'white'}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* content container */}
          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {whistleBlowing.isLoading && (
                <div className="flex-col  w-[100%] p-[10px]">
                  <Loading size="large" />
                </div>
              )}
              {!whistleBlowing.isLoading && (
                <table className="min-w-full table-auto divide-y-4 divide-white">
                  <thead className="sticky top-0 z-10 mb-4">
                    <tr className="bg-gray2 rounded-lg h-10 mb-18">
                      {WhistleblowingHeaders?.map((item, index: number) => {
                        return (
                          <th
                            key={index}
                            className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === WhistleblowingHeadersAdmin?.length - 1 ? 'border-none' : 'border-r border-white'}`}
                          >
                            <div className="flex items-center">
                              <p className="text-text1 font-semibold text-sm flex-1">
                                {item.replace(/_/g, ' ')}
                              </p>
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  let sortBy = ''
                                  switch (
                                    item as keyof WhistleblowingHeadersInterface
                                  ) {
                                    case 'ID':
                                      sortBy = 'reportNo'
                                      break
                                    case 'Status':
                                      sortBy = 'status'
                                      break
                                    case 'Subject':
                                      sortBy = 'subject'
                                      break
                                    case 'Report Type':
                                      sortBy = 'reportType'
                                      break
                                    case 'Date Reported':
                                      sortBy = 'createdAt'
                                      break
                                    case 'Updated At':
                                      sortBy = 'updatedAt'
                                      break
                                    case 'Created By':
                                      sortBy = 'createdByName'
                                      break
                                    case 'Updated By':
                                      sortBy = 'updatedByName'
                                      break
                                    default:
                                      break
                                  }
                                  handleSort(sortBy)
                                }}
                              >
                                <Icon
                                  name={'IconChevronDown'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </th>
                        )
                      })}
                      <th className="w-[56px] rounded-r-lg"></th>{' '}
                    </tr>
                  </thead>
                  <tbody>
                    {whistleBlowing?.data?.data?.map((item, index) => (
                      <>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item.reportNo}
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <div
                              className={`px-[10px] w-fit flex justify-center items-center bg-${statusBgColorWhistleblowing(item?.status)} h-[28px] rounded-[100px]`}
                            >
                              <p className="text-text2 font-medium text-xs leading-5">
                                {item.status}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {item.subject}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {item.reportType}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {formatDate(item.createdAt)}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {formatDate(item.updatedAt)}
                            </p>
                          </td>
                          {item.updatedByName && (
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-xs text-text1 font-medium leading-5">
                                {item.updatedByName == null
                                  ? ''
                                  : item.updatedByName}
                              </p>
                            </td>
                          )}
                          <td className="px-4 h-[48px] py-2 border-b border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {formatDate(item.updatedAt)}
                            </p>
                          </td>
                          <td className="px-4  py-2 border-b border-white cursor-pointer flex relative items-center h-[65px] justify-center">
                            <Menu
                              isOpen={isOpenMenu[index]}
                              items={[
                                {
                                  label: 'View',
                                  onClick: () => {
                                    setIsView(true)
                                    setId(item.id)
                                    setWhistleblowingId(item?.whistleBlowingId)

                                    // queryClient.fetchQuery([
                                    //   'whistleblowinComment',
                                    //   id,
                                    // ])
                                    handleToggleMenu(index)
                                  },
                                  icon: 'IconEye',
                                  iconColor: '',
                                  display: item?.viewAccess,
                                },
                                // {
                                //   label: 'Edit',
                                //   onClick: () => {
                                //     setIsView(true)
                                //     setId(item.id)
                                //   },
                                //   icon: 'IconEdit',
                                //   iconColor: '',
                                // },
                                {
                                  label: 'Remove',
                                  onClick: () => {
                                    setIsOpenDelete(true)
                                    setId(item.id)
                                  },
                                  display: item?.deleteAccess,
                                  icon: 'IconTrash',
                                  iconColor: '#FF6666',
                                  textColor: 'text-textError',
                                },
                              ]}
                              type={'table'}
                              setIsOpenMenu={setIsOpenMenu}
                              isOpenMenus={isOpenMenu}
                            >
                              <div onClick={() => handleToggleMenu(index)}>
                                <Icon
                                  name={'IconDotsVertical'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#02698C'}
                                />
                              </div>
                            </Menu>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
          {/* 
          <div className="absolute bottom-[20px]">
     

            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(whistleBlowing?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>
      )}
      {isView && (
        <div
          className="custom-scrollbar"
          style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
        >
          <div className="flex justify-between">
            <UISubHeaderComponent
              mainPage="Whistleblowing"
              subPage={`ID No. ${whistleBlowingById?.data?.reportNo}`}
              copy=""
              onBack={() => {
                setIsView(false)
              }}
              isViewMode={false}
            />

            {/* content container */}

            <Menu
              isOpen={isOpenMenuButton}
              items={[
                {
                  label: 'Change Status',
                  onClick: () => handleOpenModal(),
                  icon: 'IconPauseCircle',
                  iconColor: '#02698C',
                  display: whistleBlowingById?.data?.editAccess,
                },

                {
                  label: 'Delete',
                  onClick: () => {
                    setIsOpenDelete(true)
                  },
                  icon: 'IconTrash',
                  iconColor: '#FF6666',
                  textColor: 'text-textError',
                  display: whistleBlowingById?.data?.deleteAccess,
                },
              ]}
            >
              <div
                onClick={() => setIsOpenMenuButton(!isOpenMenuButton)}
                className={`gap-3 border border-gray2 items-center justify-between text-white px-4 py-3 flex rounded-3xl cursor-pointer  ${isOpenMenu ? 'bg-[#CCE1E8]' : 'bg-transparent'}`}
              >
                <Icon
                  name={'IconDotsVertical'}
                  strokeWidth={1.2}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div>
            </Menu>
          </div>
          {/* <UISubHeaderComponent
            mainPage="Whistleblowing"
            subPage={`ID No. ${whistleBlowingById?.data?.reportNo}`}
            copy=" Please add your whistleblowing reports here. You can give various reasons and solutions, and specify their severity level."
            onCreate={() => {
              handleOpenModal()
            }}
            onPublish={handleOpenModal}
            // onEdit={() => {
            //   handleOpenModal()
            // }}
            onDelete={() => {
              setIsOpenDelete(true)
            }}
            onBack={() => {
              setIsView(false)
            }}
            isViewMode={true}
          /> */}

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    ID
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.reportNo}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div
                      className={`px-[20px] rounded-[72px] w-fit py-[10px] bg-${statusBgColorWhistleblowing(whistleBlowingById?.data?.status)} flex justify-center items-center`}
                    >
                      <p className="text-text2 font-medium text-xs leading-5">
                        {whistleBlowingById?.data?.status}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Subject
                  </td>
                  <td className="px-4 h-[48px] py-2 border border-white">
                    <p className="text-text1 font-semibold text-sm leading-6">
                      {whistleBlowingById?.data?.subject}
                    </p>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.description}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Report Type
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.reportType}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.createdAt?.substring(0, 16)}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingById?.data?.updatedAt?.substring(0, 16)}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>Comments</p>

          {whistleBlowingComment?.data?.map((item, index: number) => (
            <div
              key={index}
              className="overflow-hidden rounded-[16px] w-full my-[30px]"
            >
              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                <tbody>
                  <tr className="bg-gray1">
                    {/* Example row */}
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      Created at
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                      {item.createdAt?.substring(0, 16)}
                    </td>
                  </tr>
                  <tr className="bg-gray1">
                    {/* Example row */}
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      User wrote
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                      {item.comment}
                    </td>
                  </tr>

                  {/* Add more rows as needed */}
                </tbody>
              </table>
            </div>
          ))}
          <UITextArea
            label={'Post a comment'}
            placeholder="Please describe the details of your report"
            iconName={''}
            onChange={(e) => {
              setComment(e.target.value)
            }}
          />
          {/* <div className="w-[100%] bg-paleYellow rounded-[10px] mt-[10px] h-[72px] flex-col pt-[15px] px-[20px]">
            <p className="text-text2 text-[14px] font-semibold">
              Guest report:
            </p>
            <p className="text-goldYellow text-[14px] font-semibold">
              Comments will be visible to the whistleblower.
            </p>
          </div> */}

          <div className="bg-gray3 w-full h-[1px] my-3"></div>
          <div className="w-[33%] mt-6">
            <UIButton onClick={addComment} label="Post Comment" />
          </div>
        </div>
      )}
      {/* modal */}
      <Modal
        customStyle={{ borderRadius: 16 }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] min-h-[45vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconMessageAlertSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Change Report Status
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the status of the report
            </p>
          </div>
          <div className="w-[416px] flex-col flex gap-4 mt-[10px]">
            <UiSelect
              onChange={(e) => {
                setStatus(e)
              }}
              options={[
                { value: 'open', label: 'open' },
                { value: 'closed', label: 'closed' },
              ]}
              title={'Status'}
            />
          </div>

          <button
            onClick={() => {
              handleCloseModal()
              changeStatus()
            }}
            className=" bg-bluishGreen text-white min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Update
          </button>
        </div>
      </Modal>
      <Modal
        customStyle={{ borderRadius: 16 }}
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Whistleblowing Report
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this report?
            </p>
          </div>

          <button
            onClick={removePolicy}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            // onClick={}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 8px', width: '480px' }}
        isOpen={isExportOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The CSV export file will be generated for download. Disable any
                popup blockers in your browser to ensure proper download.{' '}
                <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    exportToExcel(whistleBlowing?.data?.data, 'data', fileType)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'HTML' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const html = UIExportHtmlTable({
                      columns: columns,
                      data: whistleBlowing?.data?.data || [],
                    })
                    if (html) {
                      handleDownloadHtml(html)
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }
                  }}
                />
              )}
              {fileType == 'Text' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    handleDownloadTxt(whistleBlowing?.data?.data)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'CSV' && (
                <CSVLink
                  target="_blank"
                  filename={'data.csv'}
                  headers={fileHeader}
                  data={
                    whistleBlowing?.data?.data?.map((item) => ({
                      ID: item.reportNo,
                      Status: item.status,
                      Subject: item.subject,
                      Report_Type: item.reportType,
                      Date_Reported: item.createdAt,
                      Updated_At: item?.updatedAt,
                      Created_By: item?.createdByName,
                      Updated_By: item?.updatedByName,
                    })) || []
                  }
                >
                  <UIButton
                    label="Confirm"
                    onClick={() => {
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }}
                  />
                </CSVLink>
              )}

              <UIButton
                secondary
                label="Cancel"
                onClick={() => setIsConfrim(!isConfrim)}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UIMultiSelect
                options={[
                  { value: 'ID', label: 'ID' },
                  { value: 'Status', label: 'Status' },
                  { value: 'Subject', label: 'Subject' },
                  { value: 'Report_Type', label: 'Report_Type' },
                  { value: 'Date_Reported', label: 'Date_Reported' },
                  { value: 'Updated_At', label: 'Updated_At' },
                  { value: 'Created_By', label: 'Created_By' },
                  { value: 'Updated_By', label: 'Updated_By' },
                ]}
                title={'Select Export Columns'}
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                onChange={(value) => setFileType(value)}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'HTML',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'CSV',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'Text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'Excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'Excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <div className="w-full">
              <button
                onClick={() => {
                  if (
                    fileType == 'CSV' ||
                    fileType == 'Text' ||
                    fileType == 'HTML' ||
                    fileType == 'Excel95' ||
                    fileType == 'Excel2007'
                  )
                    setIsConfrim(!isConfrim)
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </Modal>
      <Modal
        customStyle={{ borderRadius: 16, padding: '20px 16px' }}
        isOpen={isOpenCreate}
        onClose={() => {
          setIsOpenCreate(false)
        }}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] min-h-[45vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenCreate(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconMessageAlertSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Submit a Whistleblowing Report
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please fill out the following fields
            </p>
          </div>
          <div className="w-full flex-col flex gap-4 mt-3">
            {/* <div>
              <UiSelect
                options={[
                  { value: 'Report1', label: 'Report 1' },
                  { value: 'Report2', label: 'Report 2' },
                ]}
                title={'Report Name'}
              />
            </div> */}
            <div>
              <UITextInput
                iconName={'IconEdit'}
                label="Subject*"
                placeholder="Subject"
                onChange={(e) => {
                  setSubject(e.target.value)
                }}
              />
            </div>
            <div>
              <UITextArea
                label="Description*"
                placeholder="Write description here"
                onChange={(e) => {
                  setDescription(e.target.value)
                }}
              />
            </div>
            <UIRadiobutton
              label={'Report confidentially'}
              checked={isConfidentialSelected}
              onChange={handleConfidentialClick}
              desc="You can choose to report confidentially. Your identity will only
                be known to those who handle your case in confidence, and your
                identity will appear anonymous and confidential to others in
                case processing."
            />
            <UIRadiobutton
              label={'Report anonymously'}
              checked={isAnonymousSelected}
              onChange={handleAnonymousClick}
              desc="You can choose to report anonymously if you prefer not to provide your identity to anyone in the process."
            />
            <WhistleBlowingAboutOfficer
              checked={aboutOfficer}
              onChange={setAboutOfficer}
            />
          </div>
          <div className="w-full mt-4">
            <UIButton
              onClick={() => {
                createWhistle()
              }}
              label="Submit"
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Whistleblowing
